// Container
const DefaultContainer = () => import('@/containers/DefaultContainer')
// Other Components

// Management
const ManageCompanyList = () => import('@/modules/companies/views/management/ManageCompanyList')
const ManageUserCommissionList = () => import('@/modules/companies/views/management/ManageUserCommissionList')

const CommissionCalcPreview = () => import('@/modules/companies/views/CommissionCalcPreview')
const NewCalcPreview = () => import('@/modules/companies/views/NewCalcPreview')


var routes = [
    {
        path: '/companies/manage',
        redirect: '/companies/manage/list',
        name: 'Manage Companies',
        component: DefaultContainer,
        children: [
            {
                path: 'list',
                name: 'ManageCompanyList',
                component: ManageCompanyList,
                meta: {
                    requiresAuth: true,
                    permission: false,
                },
            },
            {
				path: ':company_id/user-commissions',
				name: 'ManageUserCommissionList',
				component: ManageUserCommissionList,
				meta: {
					requiresAuth: true,
					permission: false,
				}
			},
        ]
    },
	{
		path: '/companies/commission-calc',
		redirect: '/companies/commission-calc/preview',
		component: DefaultContainer,
		children: [
			{
				path: 'preview',
				name: 'CommissionCalcPreview',
				component: CommissionCalcPreview,
			},
			{
				path: 'new-preview',
				name: 'NewCalcPreview',
				component: NewCalcPreview,
			}
		]
	}
];

export default routes;
